<div class="flex items-center">
  <p class="text-s3 lg:text-s2">
    Last Updated by
    <b>{{ updatedBy && updatedBy.name ? updatedBy.name : '-' }} </b>
    on
    {{ updatedAt ? (updatedAt | date: datetimeFormat) : '-' }}
  </p>
</div>
